module.exports = __webpack_public_path__ + "static/img/contenttitle2.039042a0.png";